import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormArray, UntypedFormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { IAddEditPlaybookFacade, IAddEditPlaybookFacadeToken } from "../../playbooks/add-edit-playbook/add-edit-playbook.facade";
import { LegalHubTabs } from "./legal-hub-side-bar";
import { Subject } from "rxjs";
import { PlaybooksListeningFacadeService } from "../../store/playbooks-listening.facade.service";

@Component({
  template: 'appLegalHubSideBarBaseComponent',
})
export abstract class LegalHubSideBarBaseComponent implements OnInit, OnDestroy {
       public playbookForm: UntypedFormGroup;
       public submitted = false;

        protected readonly DEFAULT_COLOR = '#000000';
        protected LegalHubTabs = LegalHubTabs;
        protected onDestroy$: Subject<void> = new Subject();

       constructor( 
        protected _activeModal: NgbActiveModal,
        protected _playbooksListeningFacadeService:PlaybooksListeningFacadeService,
        @Inject(IAddEditPlaybookFacadeToken) protected _addEditPlaybookFacadeService:IAddEditPlaybookFacade,
       ){

       }

       
    ngOnInit(): void {
         this._playbooksListeningFacadeService.fetchCategories();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }


    closeSiderBar(){
        this._activeModal.close({refresh_listing: false});
    }

    onSubmit(){
        this.submitted = true;
        if(this.playbookForm?.valid){
            const form = this.playbookForm.value;
            this._addEditPlaybookFacadeService.onSubmit(form, form.id);
        }
    }

    get isSettingsTabInvalid(): boolean {
        return this.playbookForm.get('name')?.invalid ||
               this.playbookForm.get('category')?.invalid ||
               this.playbookForm.get('status')?.invalid ||
               this.playbookForm.get('color')?.invalid;
    }

    get isGuidelinesTabInvalid(): boolean {
        const guidelines = this.playbookForm.get('guidelines') as FormArray;
        return guidelines.controls.some(control => control.invalid);
    }

}